import { readUsers } from "@directus/sdk";
import { getDirectusClient } from "../lib/directus";

export const obtenerUsuariosPorSuperior = async (superiorId) => {
  try {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        filter: {
          _and: [
            {
              superior: {
                _eq: superiorId,
              },
            },
          ],
        },
        fields: ["id", "first_name", "last_name", "superior", "tope_de_prestamo", "prestamo_usado"],
      })
    );
    return response;
  } catch (error) {
    console.error("Error obteniendo usuarios por superior:", error);
    throw error;
  }
};
